module.exports = __webpack_public_path__ + "media/images/blue_day-645fc911feedfd5eeb350b9b9fffa592.png";